<template>
  <div class="c-chart">
    <p class="c-chart__title">该章节在松鼠Ai智适应系统中拆分了<span>{{data.length}}个</span>纳米知识点
      <span class="c-chart__title__hint">点击图谱中知识点, 可查看该知识点的视频讲义</span>
    </p>
    <p class="c-legend">
      <span
        v-for="item in legend"
        :key="item.name"
        :style="{color: item.color}"
        style="">{{item.name}}</span>
    </p>
    <div class="chart-dom-container" ref="container">
      <div ref="chart" class="chart-dom"></div>
    </div>
    <p class="c-chart__subtitle">《{{course.lessonName}}》知识图谱</p>
    <lo-dialog
      :visible.sync="visibleLo"
      v-if="visibleLo"
      :code="currentCode"
      :subject-id="subjectId"
      :data="data" />
  </div>
</template>

<script>
import loDialog from './lo-dialog.vue';

export default {
  components: { loDialog },
  name: 'KnowledgeChart',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    edges: {
      type: Array,
      default: () => [],
    },
    course: {
      type: Object,
      default: () => ({}),
    },
    subjectId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      visibleLo: false,
      currentCode: '',
      legend: [{
        name: '低考频',
        icon: 'circle',
        color: 'rgba(59, 183, 111, 1)',
        textStyle: {
          color: 'rgba(59, 183, 111, 1)',
        },
      }, {
        name: '中考频',
        icon: 'circle',
        color: 'rgba(237, 189, 0, 1)',
        textStyle: {
          color: 'rgba(237, 189, 0, 1)',
        },
      }, {
        name: '高考频',
        icon: 'circle',
        color: 'rgba(246, 103, 106, 1)',
        itemWidth: 50,
        itemHeight: 50,
        textStyle: {
          color: 'rgba(246, 103, 106, 1)',
        },
      }],
    };
  },
  watch: {
    edges: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.init();
          this.setListener();
        });
      },
    },
  },
  methods: {
    // echarts 初始化
    init() {
      this.chart = this.$echarts.init(this.$refs.chart);
      this.chart.setOption({
        color: this.legend.map((item) => item.color),
        // legend: {
        //   data: this.legend,
        // },
        legendHoverLink: true,
        series: [{
          data: this.data,
          focusNodeAdjacency: true,
          // focus: 'adjacency',
          edgeSymbol: ['circle', 'arrow'],
          edgeSymbolSize: [1, 10],
          force: {
            edgeLength: 230,
            repulsion: 210,
          },
          lineStyle: {
            color: 'source',
            curveness: 0.1,
          },
          type: 'graph',
          layout: 'force',
          animation: true,
          draggable: false,
          categories: this.legend,
          edges: this.edges,
          symbolSize: 18,
          label: {
            show: true,
            position: 'top',
            // color: 'source',
          },
          emphasis: {
            itemStyle: {
              color: '#1989FA',
              symbolSize: 26,
              borderWidth: '2px',
              borderColor: '#1989FA',
            },
            label: {
              color: '#1989FA',
              fontSize: '16px',
            },
          },
        }],
      });
      setTimeout(() => {
        const { width, height } = this.$refs.container.getBoundingClientRect();
        const { width: iWidth, height: iHeight } = this.$refs.chart.getBoundingClientRect();
        this.$refs.container.scrollLeft = (iWidth - width) / 2;
        this.$refs.container.scrollTop = (iHeight - height) / 2;
      }, 30);
    },
    setListener() {
      this.chart.on('click', this.showLo);
    },
    // 展现知识点详情
    showLo(node) {
      if (node.dataType !== 'node') {
        return;
      }
      this.visibleLo = true;
      this.currentCode = node.data.knowledge_code;
    },
    setHighlight(index = 0) {
      this.chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: index,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-chart {
  &__title {
    color: #000;
    font-size: 15px;
    padding-left: 24px;
    margin: 26px 0;
    span {
      color: rgba(25, 137, 250, 1) ;
    }
    &__hint {
      float: right;
      color: rgba(48, 49, 51, 0.6) !important;
    }
  }
  &__subtitle {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
  }
  .chart-dom-container {
    height: 500px;
    overflow: auto;
  }
  .chart-dom {
    width: 150%;
    height: 750px;
    // width: 1000px;
  }
  .c-legend {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      position: relative;
      padding-left: 15px;
      padding-right: 10px;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: currentColor;
      }
    }
  }
}
</style>
